import { render } from "./RegenereTestTabPane.vue?vue&type=template&id=b34dee08&scoped=true"
import script from "./RegenereTestTabPane.vue?vue&type=script&lang=js"
export * from "./RegenereTestTabPane.vue?vue&type=script&lang=js"

import "./RegenereTestTabPane.vue?vue&type=style&index=0&id=b34dee08&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b34dee08"]])

export default __exports__